/* PRODUCTS */
export const GET_SAVED_SEARCH = "GET_SAVED_SEARCH"
export const GET_SAVED_SEARCH_SUCCESS = "GET_SAVED_SEARCH_SUCCESS"
export const GET_SAVED_SEARCH_FAIL = "GET_SAVED_SEARCH_FAIL"

export const DELETE_SAVED_SEARCH = "DELETE_SAVED_SEARCH"
export const DELETE_SAVED_SEARCH_SUCCESS = "DELETE_SAVED_SEARCH_SUCCESS"
export const DELETE_SAVED_SEARCH_FAIL = "DELETE_SAVED_SEARCH_FAIL"
